import { render, staticRenderFns } from "./MessageContentFile.vue?vue&type=template&id=c9cb2774&scoped=true&"
import script from "./MessageContentFile.vue?vue&type=script&lang=js&"
export * from "./MessageContentFile.vue?vue&type=script&lang=js&"
import style0 from "./MessageContentFile.vue?vue&type=style&index=0&id=c9cb2774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cb2774",
  null
  
)

export default component.exports